import { createContext } from "react";
import type { BrandingContextValue as BrandingContextValueType } from "../types";

export const BrandingContext = createContext<
  BrandingContextValueType | undefined
>(undefined);
